import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    Table, TableBody, TableRow, TableCell, TextField,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";

const AgreementEditPage = () => {
    const { clientId, agreementId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [agreement, setAgreement] = useState({
        contactId: clientId,
        type: 0,
        conclusionDate: '',
        terminationDate: null,
        feeInPercent: ''
    });

    useEffect(() => {
        const fetchAgreement = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (agreementId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_AGREEMENTS_URL}/single/${agreementId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setAgreement(data.data);
                    } else {
                        console.log('Fetch agreement failed.');
                    }
                } else {
                    setAgreement({
                        contactId: clientId,
                        type: 0,
                        conclusionDate: '',
                        terminationDate: null,
                        feeInPercent: ''
                    });
                    console.log(agreement);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchAgreement();
    }, [agreementId]);

    const validateForm = () => {
        let newErrors = {};

        if (agreement.type === '') {
            newErrors.type = 'Type is required.';
        }

        if (agreement.conclusionDate === '') {
            newErrors.conclusionDate = 'Conclusion Date is required.';
        }

        if (agreement.feeInPercent === '' || agreement.feeInPercent === 0) {
            newErrors.feeInPercent = 'Fee is required.';
        } else if (isNaN(agreement.feeInPercent)) {
            newErrors.feeInPercent = 'Fee must be number.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setAgreement({
            ...agreement,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_AGREEMENTS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(agreement),
                }
            );
            if (response.ok) {
                console.log('Agreement updated successfully.');
                handleGoBack();
            } else {
                console.log('Update agreement failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {agreementId ? 'Edit Brokerage Agreement' : 'Create Brokerage Agreement'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={agreement.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('brokerageAgreementType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Conclusion Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="conclusionDate"
                                label="Conclusion Date"
                                value={dayjs(agreement.conclusionDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'conclusionDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.conclusionDate}
                                helperText={errors.conclusionDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Termination Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="terminationDate"
                                label="Termination Date"
                                value={dayjs(agreement.terminationDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'terminationDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Fee, %</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="feeInPercent"
                                label="Fee, %"
                                value={agreement.feeInPercent}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.feeInPercent}
                                helperText={errors.feeInPercent}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default AgreementEditPage;
